import { Fragment } from 'react/jsx-runtime';
import { FolderStructureIcons } from '../../assets/icons/FolderStructure';
import { TreeNodeProps } from '../../types/chatTypes'
import { CodeContent } from '../../types/codeBaseType';

const TreeNodeComponent = ({ node, toggleFolder, level = 0, codeContent }: TreeNodeProps & { level?: number, codeContent?: CodeContent }) => {
    const { Folder, File, ArrowRight, ArrowDown } = FolderStructureIcons;
    return (
        <Fragment>
            <li className={`tree-node ${codeContent?.fileName === node.name ? 'selected' : ''}`}>
                <button className="node not-a-button" onClick={() => toggleFolder(node)} style={{ paddingLeft: level ? `${level * 36}px` : "10px" }}>
                    {node.type === "dir" ? (
                        <>
                            <img src={node.isOpen ? ArrowDown : ArrowRight} alt="toggle" />
                            <img src={Folder} alt="folder" />
                        </>
                    ) : (
                        <img src={File} alt="file" />
                    )}
                    <div className="nodeName">{node.name}</div>
                </button>

            </li>
            {
                node.isOpen && node.children && (
                    <ul>
                        {node.children.map((child) => (
                            <TreeNodeComponent key={child.sha} node={child} toggleFolder={toggleFolder} level={level + 1} />
                        ))}
                    </ul>
                )
            }
        </Fragment>
    )
};

export default TreeNodeComponent